export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4352.2902494331065,
    ],
    button_spin: [
      6000,
      526.8027210884352,
    ],
    buy_button: [
      8000,
      2616.598639455782,
    ],
    coins_koala: [
      12000,
      3021.4965986394554,
    ],
    counter_total: [
      17000,
      432.47165532879706,
    ],
    end_free_spin: [
      19000,
      1789.387755102041,
    ],
    free_bet_big_win: [
      22000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      25000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      29000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      31000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      34000,
      53385.57823129253,
    ],
    free_spin_music: [
      89000,
      49262.585034013595,
    ],
    free_spin_start: [
      140000,
      3229.0249433106624,
    ],
    inside_buttons: [
      145000,
      239.4557823129162,
    ],
    lamp_cracking: [
      147000,
      8671.201814058946,
    ],
    main_ambient: [
      157000,
      63085.71428571429,
    ],
    main_music: [
      222000,
      166611.88208616784,
    ],
    mega_win: [
      390000,
      4744.126984126979,
    ],
    outside_button: [
      396000,
      161.08843537415396,
    ],
    reel_spin: [
      398000,
      2253.7868480725365,
    ],
    reel_stop_01: [
      402000,
      140.77097505668235,
    ],
    reel_stop_02: [
      404000,
      137.86848072561497,
    ],
    reel_stop_03: [
      406000,
      166.8934240362887,
    ],
    reel_stop_04: [
      408000,
      123.3560090702781,
    ],
    reel_stop_05: [
      410000,
      184.30839002269295,
    ],
    regular_win: [
      412000,
      1017.3242630385744,
    ],
    respin: [
      415000,
      5289.795918367361,
    ],
    scatter_chance: [
      422000,
      4584.489795918387,
    ],
    scatter_stop: [
      428000,
      1322.086167800478,
    ],
    select_bonus_game: [
      431000,
      5670.022675736959,
    ],
    select_bonus_game_koala: [
      438000,
      5670.022675736959,
    ],
    shooting_free_spin_popup: [
      445000,
      3864.671201814076,
    ],
    tap_to_play: [
      450000,
      10229.841269841245,
    ],
    transition_past_time: [
      462000,
      13654.78458049887,
    ],
    ultra_win: [
      477000,
      4172.335600907047,
    ],
    x1_mult: [
      483000,
      3408.979591836726,
    ],
    x3_mult: [
      488000,
      4085.260770975083,
    ],
    x5_mult: [
      494000,
      3635.3741496598673,
    ],
    x7_mult: [
      499000,
      4018.503401360533,
    ],
    x9_mult: [
      505000,
      3156.462585034035,
    ],
  },
}
